angular
  .module 'gym.components'
  .directive 'memberStyle', ->
    restrict: 'E'
    template: require('templates/components/contacts/member_style.html.slim')
